import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'
import { RouteLoader } from 'src/components/Loader'
import AppErrorBoundary from 'src/components/AppErrorBoundary'

import 'src/assets/styles/app.scss'

ReactDOM.render(
    <AppErrorBoundary>
        <React.Suspense fallback={<RouteLoader />}>
            <App />
        </React.Suspense>
    </AppErrorBoundary>,
    document.getElementById('root')
)
